/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useQuery } from '@tanstack/react-query';
import { billingCatalogService } from '@/services/billing/billing-catalog.service';
import { ModulePricingTier, VolumeDiscountRule } from '@/types/superadmin.types';
import { ApiError } from '@/services/api/types';

export const billingCatalogKeys = {
  all: ['billingCatalog'] as const,
  tiers: () => [...billingCatalogKeys.all, 'tiers'] as const,
  discounts: () => [...billingCatalogKeys.all, 'discounts'] as const,
};

export function useBillingCatalogTiers(moduleCode?: string) {
  return useQuery<ModulePricingTier[], ApiError>({
    queryKey: billingCatalogKeys.tiers(),
    queryFn: () => billingCatalogService.getTiers(moduleCode),
    staleTime: 5 * 60 * 1000,
  });
}

export function useBillingCatalogDiscounts() {
  return useQuery<VolumeDiscountRule[], ApiError>({
    queryKey: billingCatalogKeys.discounts(),
    queryFn: () => billingCatalogService.getDiscounts(),
    staleTime: 5 * 60 * 1000,
  });
}
